enum Web {
  SINGLE_SIGN_ON = 'web-react-sso',
  TEST = 'web-react-test',
  REQUIRE_MOBILE_PHONE = 'web-react-require-mobile-phone',
  SELF_QUALIFICATION_SIGNUP_FIELDS = 'growth-self-qualification-signup-fields',
  COOKIE_MANAGEMENT = 'web-cookie-management',
}

enum Mobile {
  MOBILE_DS_SHARE = 'mobile-ds-share',
}

enum DesignStudio {
  DS_MACHETE_ENVIRONMENT_TYPE = 'DS_macheteEnvironmentTypeTreatment',
  DS_MACHETE_QUALITY = 'DS_macheteQualityTreatment',
  DS_MACHETE_USE_PRODUCTS_LIBRARY_FOR_TEXTURING = 'DS_useProductsLibraryForTexturingTreatment',
  DS_PROTOTYPE_POST_MESSAGE_EVENTS = 'DS_prototype-post-message-events',
  DS_SHARE = 'DS_share',
  DS_SHOW_DESIGN_CHANGES = 'DS_show-design-changes-in-pro-view',
  DS_SHOW_DESIGN_CHANGES_IN_SHARE = 'DS_show-design-changes-in-share',
  DS_UNDO_REDO = 'DS_undo-redo',
  DS_JH_PRODUCTS = 'DS_james-hardie-products',
}

const Value = {
  CONTROL: 'control',
  OFF: 'off',
  ON: 'on',
} as const;

const localhostFeaturesKey = 'local-split-features';

// eslint-disable-next-line @typescript-eslint/no-redeclare
type Value = typeof Value[keyof typeof Value];

export { DesignStudio, Mobile, Value, Web, localhostFeaturesKey };
